export function isWalletProviderDescriptor(p) {
    return typeof p.loadProvider === 'function';
}
/** Shared WalletConnect project metadata for EVM and Solana packages. */
